import { HttpResult } from 'widgets-for-react'
import { cmsPageUrl } from '../../utils/cmsPageUrl'
import { CentrumPageData, DepartmentPageData } from '../cmsPage/sharepointPageApi/types/pageData'
import { DepartmentOrCentrum } from './departmentsAndCentraOverviewState'

type DepartmentsAndCentraPages = {
  DepartmentPages: DepartmentPageData[]
  CentrumPages: CentrumPageData[]
}

export const departmentsAndCentraOverviewApi = async (): Promise<HttpResult<DepartmentOrCentrum[]>> => {
  const res = await fetch('/api/v1/pages/department-or-centrum')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: DepartmentsAndCentraPages = await res.json()

  document.title = 'Afdelingen en centra | Spaarne Gasthuis'

  return {
    kind: 'result',
    status: 200,
    value: data.DepartmentPages.map((item) => ({
      id: item.SharepointId,
      title: (item.HeaderTitle[0] ?? "").toUpperCase() + item.HeaderTitle.slice(1),
      intro: item.TeaserDescription || item.HeaderDescription,
      url: cmsPageUrl(item),
    })).concat(
      data.CentrumPages.map((item) => ({
        id: item.SharepointId,
        title: (item.HeaderTitle[0] ?? "").toUpperCase() + item.HeaderTitle.slice(1),
        intro: item.TeaserDescription || item.HeaderDescription,
        url: cmsPageUrl(item),
      }))
    ),
  }
}
